/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DialogueResultPaginatedResult,
  DialogueWithMessagesResult,
  MessageResult,
  MessageResultPaginatedResult,
  ProblemDetails,
  SendPrivateMessageRequest,
  UserResult
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Chat<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Chat
   * @name GlobalMessageCreate
   * @summary Sends a global message.
   * @request POST:/chat/global/message
   * @secure
   */
  globalMessageCreate = (
    query: {
      /** @minLength 1 */
      request: string;
      uuid: string;
    },
    params: RequestParams = {}
  ) =>
    this.request<MessageResult, ProblemDetails>({
      path: `/chat/global/message`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Chat
   * @name PrivateMessageCreate
   * @summary Sends a private message.
   * @request POST:/chat/private/message
   * @secure
   */
  privateMessageCreate = (
    data: SendPrivateMessageRequest,
    params: RequestParams = {}
  ) =>
    this.request<MessageResult, ProblemDetails>({
      path: `/chat/private/message`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Chat
   * @name GlobalMessagesDelete
   * @summary Deletes and archives a global message.
   * @request DELETE:/chat/global/messages/{id}
   * @secure
   */
  globalMessagesDelete = (id: number, params: RequestParams = {}) =>
    this.request<MessageResult, ProblemDetails>({
      path: `/chat/global/messages/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Chat
   * @name PrivateMessagesDelete
   * @summary Deletes and archives a private message.
   * @request DELETE:/chat/private/messages/{id}
   * @secure
   */
  privateMessagesDelete = (id: number, params: RequestParams = {}) =>
    this.request<MessageResult, ProblemDetails>({
      path: `/chat/private/messages/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Chat
   * @name GlobalUsersList
   * @summary Gets all available users that may receive personal message.
   * @request GET:/chat/global/users
   * @secure
   */
  globalUsersList = (params: RequestParams = {}) =>
    this.request<UserResult[], ProblemDetails>({
      path: `/chat/global/users`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Chat
   * @name GlobalList
   * @summary Gets all global messagess
   * @request GET:/chat/global
   * @secure
   */
  globalList = (
    query?: {
      /**
       * @format int32
       * @min 0
       * @max 2147483647
       */
      offset?: number;
      /**
       * @format int32
       * @min 1
       * @max 100
       */
      limit?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<MessageResultPaginatedResult, ProblemDetails>({
      path: `/chat/global`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Chat
   * @name PrivateDialoguesList
   * @summary Gets all private dialogues
   * @request GET:/chat/private/dialogues
   * @secure
   */
  privateDialoguesList = (
    query?: {
      /**
       * @format int32
       * @min 0
       * @max 2147483647
       */
      offset?: number;
      /**
       * @format int32
       * @min 1
       * @max 100
       */
      limit?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<DialogueResultPaginatedResult, ProblemDetails>({
      path: `/chat/private/dialogues`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Chat
   * @name PrivateDialogueMessagesList
   * @summary Gets all messages from a dialogue
   * @request GET:/chat/private/dialogue/messages
   * @secure
   */
  privateDialogueMessagesList = (
    query: {
      interlocutorId: string;
      /**
       * @format int32
       * @min 0
       * @max 2147483647
       */
      offset?: number;
      /**
       * @format int32
       * @min 1
       * @max 100
       */
      limit?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<DialogueWithMessagesResult, ProblemDetails>({
      path: `/chat/private/dialogue/messages`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
}
